<template>
  <b-container>
    <h3>{{ fieldValue.fieldName }}</h3>

    <div
      v-for="data in fieldValue.subForm.blocks"
      :key="data.sequecenceNumber"
      class="divCard"
    >
      <div v-if="data.active">
        <b-row lg="6" md="6" sm="12" class="div-row-padding">
          <b-col lg="9" md="9" sm="12" class="div-row-padding" >
            <h4 class="mt-2">
              {{ fieldValue.subForm.title }} #{{ data.sequenceNumber }}
            </h4>
          </b-col>
          <b-col class="ml-4">
            <a
              class="h4"
              v-if="!data.hide"
              href="#"
              @click.prevent="hideBlock(data)"
              ><label
                ><b-icon icon="eye-slash" aria-hidden="true"></b-icon></label
            ></a>
            <a
              class="h4"
              v-if="data.hide"
              href="#"
              @click.prevent="showBlock(data)"
              ><label><b-icon icon="eye" aria-hidden="true"></b-icon></label
            ></a>
          </b-col>
          <b-col>
            <a class="h4" href="#" @click.prevent="removeBlock(data)"
              ><label><b-icon icon="trash" aria-hidden="true"></b-icon></label
            ></a>
          </b-col>
        </b-row>
        <div v-if="!data.hide">
          <sub-checklist-fill-field
            :checklist="checklist"
            :values="data.values"
            :modelstate="modelstate"
            :token="token"
          ></sub-checklist-fill-field>
        </div>
      </div>
    </div>

    <b-button size="sm" class="mb-3" @click="addBloc"
      >Adicionar {{ fieldValue.subForm.title }}</b-button
    >

    <!-- <pre class="language-json"><code>{{ fieldValue.subForm  }}</code></pre> -->
  </b-container>
</template>
<script>
export default {
  name: "SubChecklistToFill",
  props: {
    fieldValue: Object,
    modelstate: Object,
    autosaveValues: Array,
    checklist: Object,
    token: {
      description: "Token de acesso",
      type: String,
      required: true
    }
  },
  components: {
    SubChecklistFillField: () => import("./SubChecklistFillField.vue"),
  },
  created() {},
  computed: {},
  data() {
    return {
      newFields: [],
      show: true,
    };
  },
  methods: {
    addBloc() {
      let fieldsConfig = this.fieldValue.subForm.fieldsConfig;
      const newBlock = {
        id: 0,
        active: true,
        hide: false,
        title: this.fieldValue.subForm.title,
        subFormFieldId: this.fieldValue.subForm.subFormFieldId,
        subFormId: this.fieldValue.subForm.subFormId,
        sequenceNumber: this.getNextSequenceNumber(),
        values: [],
      };
      for (let i = 0; i < fieldsConfig.length; i++) {
        const newField = {
          id: 0,
          displaySequence: i,
          fieldDefaultValue: fieldsConfig[i].fieldDefaultValue,
          fieldId: fieldsConfig[i].fieldId,
          fieldName: fieldsConfig[i].fieldName,
          fieldTip: fieldsConfig[i].fieldTip,
          fieldType: fieldsConfig[i].fieldType,
          systemFieldTypeId: fieldsConfig[i].systemFieldTypeId,
          selectedValue: fieldsConfig[i].selectedValue,
          allowsAttachment: fieldsConfig[i].allowsAttachment,
          required: fieldsConfig[i].required,
          value: "",
          hasAttachment: fieldsConfig[i].hasAttachment,
          attachment: fieldsConfig[i].attachment,
          anomaly: fieldsConfig[i].anomaly,
          isMandatoryAttachment: fieldsConfig[i].isMandatoryAttachment,
          attachments: [],
          options: fieldsConfig[i].options,
          attachmentMobileMode: fieldsConfig[i].attachmentMobileMode,
          ocrType: fieldsConfig[i].ocrType,
          ocrScanLog: null,
          fieldValue: null,
        };

        newBlock.values.push(newField);
      }
      this.fieldValue.subForm.blocks.push(newBlock);
    },

    getNextSequenceNumber() {
      let sequence = 0;
      for (let item of this.fieldValue.subForm.blocks) {
        if (item.active == true) {
          if (item.sequenceNumber > sequence) {
            sequence = item.sequenceNumber;
          }
        }
      }
      return sequence + 1;
    },

    removeBlock(block) {
      if (!block || block.id == 0) {
        let blockIndex = this.fieldValue.subForm.blocks.indexOf(block);
        if (blockIndex >= 0) {
          this.fieldValue.subForm.blocks.splice(blockIndex, 1);
        }
      } else {
        block.active = false;
      }

      let activeBlocks = [];
      for (let block of this.fieldValue.subForm.blocks.sort(
        (c1, c2) => c1.sequenceNumber - c2.sequenceNumber
      )) {
        if (block.active) {
          activeBlocks.push(block);
        }
      }

      for (let i = 0; i < activeBlocks.length; i++) {
        activeBlocks[i].sequenceNumber = i + 1;
      }
    },

    hideBlock(block) {
      block.hide = true;
      $this.$forceUpdate();
    },
    showBlock(block) {
      block.hide = false;
      $this.$forceUpdate();
    },

    loadValuesFill() {},
  },
};
</script>